import React from 'react';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';

import { ExpandableCard } from 'core/components/expandable-card';
import { useStore } from 'core/store';
import { PolicyTypeOption } from './policy-type-option';
import { ToggleRentersButton } from './toggle-renters-button';

const policyTypeOptions = ['H', 'HB', 'HA', 'A', 'AB', 'AR'];

const policyTypeLabelMap = {
  H: 'Home',
  HB: 'Home with Bundle Discount',
  HA: 'Home & Auto',
  A: 'Auto',
  AB: 'Auto with Bundle Discount',
  AR: 'Auto & Renters'
};

const inputOptionsMap = {
  H: [{ value: 'H', label: 'Home' }],
  HA: [{ value: 'HA', label: 'Home & Auto' }],
  HB: [{ value: 'HB', label: 'Home with Bundle Discount' }],
  A: [{ value: 'A', label: 'Auto' }],
  AB: [{ value: 'AB', label: 'Auto with Bundle Discount' }],
  AR: [{ value: 'AR', label: 'Auto & Renters' }]
};

const getOption = (type, offer) => {
  const isAutoBundle = type === 'AB';
  const isHomeBundle = type === 'HB';
  const option = offer.options.find((opt) => (isAutoBundle || isHomeBundle ? opt.type === 'HA' : opt.type === type));

  if (!option) {
    return null;
  }

  const autoData = {
    autoPrice: option.autoBill,
    autoFrequency: offer.quote.global.autoPaymentType === 'I' ? 'Avg. Monthly' : '6 months'
  };

  const homeData = {
    homePrice: option.homeBill,
    homeFrequency: offer.quote.global.homeownersPaymentType === 'I' ? 'Avg. Monthly' : '12 months'
  };

  if (isAutoBundle) {
    return autoData;
  }
  if (isHomeBundle) {
    return homeData;
  }
  return { ...homeData, ...autoData };
};

const PolicyPickerCard = observer(() => {
  const {
    offer: store,
    offer: {
      offer: {
        quote: {
          existingCustomer,
          offerings: { monolineAutoRejectCode }
        },
        options
      }
    }
  } = useStore();
  const { values } = useFormikContext();
  const linkedToExistingCustomer = !!existingCustomer?.id;

  const hasMonolineAutoOption = options.some((opt) => {
    return opt.type === 'A';
  });

  return (
    <ExpandableCard title="Type" badge={policyTypeLabelMap[values.selectedOption]}>
      {policyTypeOptions.map((type, ix) => {
        const option = getOption(type, store.offer);
        let noAutoWBundle = false;
        let noAuto = false;
        if (!hasMonolineAutoOption || monolineAutoRejectCode) {
          noAuto = type === 'A';
          noAutoWBundle = !existingCustomer && type === 'AB';
        }
        if (!option) {
          return null;
        }

        return (
          <PolicyTypeOption
            onClick={() => store.setSelectedOption(type)}
            key={ix}
            option={option}
            type={type}
            label={policyTypeLabelMap[type].toUpperCase()}
            fieldOptions={inputOptionsMap[type]}
            noAutoWBundle={noAutoWBundle}
            noAuto={noAuto}
            linkedToExistingCustomer={linkedToExistingCustomer}
          />
        );
      })}
      <ToggleRentersButton />
    </ExpandableCard>
  );
});

export default PolicyPickerCard;
